import React, {useState} from 'react';
import { Link } from 'react-router-dom';
import './nav.css';
import { Logo } from '../logo/Logo';

export const Nav = () => {

    const [mobileMenu, setMobileMenu] = useState(false)
    const[activeLink, setActiveLink] = useState(false)

    const hideMobileMenu = () => {
        setMobileMenu(!mobileMenu)
    }
    const updateActiveLink =(value) => {
        setActiveLink(value)
    }

    let sections = document.querySelectorAll('section')
    
    window.onscroll = () => {
        sections.forEach(sect => {
            let top = window.scrollY;
            let offset = sect.offsetTop - 150;
            let height = sect.offsetHeight;

            if(top >= offset && top < offset + height){
                sect.classList.add('show_animate')
            } else {
                sect.classList.remove('show_animate')
            }
        })
    }


  return (
    <nav className="navbar">
        <div className="navbar_container">
            <logo id="/#hero" className="logo_container">
                <Logo className="navbar_logo"/>
            </logo>
            <div className={`navbar_toggle ${mobileMenu && 'is_active'}`} id="mobile_menu" onClick={hideMobileMenu}>
                <span className="bar"></span>
                <span className="bar"></span>
                <span className="bar"></span>
                <span className='animate' style={{'--i':"2"}}></span> 
            </div>
            <ul className={`navbar_menu ${mobileMenu && 'active'} `}>
                <li className="navbar_item">
                    <a  href="/#about_section" className={activeLink === 'About Me' ? 'active navbar_links' : 'navbar_links'} onClick={() => updateActiveLink('About Me')
                    }>About Me</a>
                </li>
                <li className="navbar_item">
                    <a href="/#expertise" className={activeLink === 'Expertise' ? 'active navbar_links' : 'navbar_links'} onClick={() => updateActiveLink('Expertise')
                    }>Expertise</a>
                </li>
                <li className="navbar_item">
                    <a href="/#projects" className={activeLink === 'Projects' ? 'active navbar_links' : 'navbar_links'} onClick={() => updateActiveLink('Projects')
                    }>Projects</a>
                </li>
                <li className="navbar_item">
                    <a href="/#contact" className={activeLink === 'Contact' ? 'active navbar_links' : 'navbar_links'} onClick={() => updateActiveLink('Contact')
                    }>Contact</a>
                </li>
                <li className="navbar_item">
                <Link to="/resume" className="navbar_links nav_button">Resume</Link>
                </li>
                <span className='animate' style={{'--i':"2"}}></span> 
            </ul>
        </div> 
    </nav>
    
  )
}
